import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: ${(props) => (props.open ? "block" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    z-index: 999;
  }
`;

export default Overlay;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Overlay/index.jsx